"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determine buttonVariant depending on context of theme and moodTheme.
 * neutral-black and neutral-white act differently depending on light or dark theme.
 */
function buttonVariant(theme, moodTheme) {
    if (theme.block.isLight && moodTheme.block.isDark) {
        return 'neutral-white';
    }
    if (theme.block.isDark && moodTheme.block.isLight) {
        return 'neutral-white';
    }
    return 'neutral-black';
}
/**
 * Enhance theme tokens with `experimentalBlocks` tokens for overriding key Carina component tokens references
 */
function withExperimentalMoodTokens(theme, moodTheme) {
    var backgroundColorClickTokens = moodTheme.block.isLight
        ? moodTheme.backgroundColor.clickNeutral
        : moodTheme.backgroundColor.clickHardNeutral;
    return __assign(__assign({}, theme), { experimentalBlocks: __assign(__assign({}, moodTheme.experimentalBlocks), { buttonVariant: buttonVariant(theme, moodTheme), backgroundColor: __assign(__assign({}, moodTheme.backgroundColor), { clickNeutral: __assign(__assign({}, backgroundColorClickTokens), { base: moodTheme.backgroundColor.base }), brand: __assign(__assign({}, moodTheme.backgroundColor.brand), { fill: __assign(__assign({}, moodTheme.backgroundColor.brand.fill), { 
                        // Selected option
                        surface: moodTheme.block.isLight
                            ? moodTheme.backgroundColor.brand.fill.surface
                            : moodTheme.backgroundColor.clickSoft.active }) }), 
                // Accordion, Textbox, Textarea, and Tile take a transparent background
                interactive: __assign(__assign({}, moodTheme.backgroundColor.interactive), { base: 'transparent', 
                    // DateRangePicker selected "middle" section
                    surface: moodTheme.block.isCloseToWhite
                        ? moodTheme.backgroundColor.interactive.surface
                        : moodTheme.block.accent }), neutral: __assign(__assign({}, moodTheme.backgroundColor.neutral), { 
                    // Carousel Prev/Next background
                    base: theme.backgroundColor.neutral.fill.surface }) }), font: {
                color: __assign(__assign({}, moodTheme.font.color), { neutral: __assign(__assign({}, moodTheme.font.color.neutral), { 
                        // Carousel Prev/Next icon
                        base: theme.font.color.neutral.fill }) })
            }, borderColor: __assign(__assign({}, moodTheme.borderColor), { accent: __assign(__assign({}, moodTheme.borderColor.accent), { focus: moodTheme.font.color.base }) }) }) });
}
exports.default = withExperimentalMoodTokens;
//# sourceMappingURL=withExperimentalMoodTokens.js.map